<template>
    <div>
        <p class="label">{{ label }}</p>
        <MultiplePickerInput :value="value" @input="onInput" :items="items" v-bind="$attrs" />
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';
  import CountryService from '@/services/country.service.js';

  export default {
    name: "CountryMultiplePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: Array,
      label: { type: String, default: 'Pays'}
    },
    data() {
      return {
        items: [],
      }
    },
    created() {
      this.loadListItem();
    },
    methods: {
      loadListItem() {
        const _this = this;

        CountryService.getListByStudent().then(({data}) => {
          _this.items = data;
        });
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
  }
</script>

<style scoped>

</style>
